import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-form-error.css'

const GridFormError = ({ field }) => {
  if (field.touched && field.error) {
    return <div styleName="error">{field.error}</div>
  }

  return null
}

GridFormError.propTypes = {
  field: PropTypes.object,
}

export default CSSModules(GridFormError, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-error/grid-form-error.js
 **/